import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import SubNavbar from '../components/SubNavbar';
import ActionButton from '../../ActionButton';
import { getRouteName } from '../../../utils/routesNames';
import { routes } from '../../../pages';

import './_membersNav.scss';

const MembersNav = () => {
  const { pathname } = useLocation();
  const { dataTable } = useSelector(s => s.members);
  const { data: { is_group_admin } } = useSelector(s => s.account);

  return (
    <div className="membersNav">
      <SubNavbar route={`${getRouteName(pathname)} ${!isEmpty(dataTable) ? '(' + dataTable.length + ')' : ''}`}>
        {is_group_admin && <ActionButton variant="secondary" title="Invite Member" to={routes.members.invite.path}/>}
      </SubNavbar>
    </div>
  );
};

export default MembersNav;